import { render, staticRenderFns } from "./schema-dialog.vue?vue&type=template&id=2847e51d&scoped=true"
import script from "./schema-dialog.vue?vue&type=script&lang=js"
export * from "./schema-dialog.vue?vue&type=script&lang=js"
import style0 from "./schema-dialog.vue?vue&type=style&index=0&id=2847e51d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847e51d",
  null
  
)

export default component.exports